<template>
  <div class="documentation-list-header">
    <h2 class="documentation-list-header__title">Dokumentasjon</h2>
  </div>
</template>

<script setup lang="ts">
// No props needed for this simple header component
</script>

<style lang="scss" scoped>
.documentation-list-header {
  &__title {
    font-size: 1.25rem;
    font-weight: 600;
    color: $color-primary-darker;
    margin-bottom: 1.5rem;

    @media (max-width: $bp-sm) {
      font-size: 1.125rem;
      margin-bottom: 1rem;
    }
  }
}
</style>
